<template>
    <div class="d-flex align-center mr-2">
        <div class="ml-4 text-h5 font-weight-light">
            Dashboard
        </div>
        <div class="flex-grow-1">
            <slot></slot>
        </div>

        <template v-if="$store.state.ref.dashboard.tabIndex !== 0">
            <app-toolbar-date-selector :range="this.$store.state.ref.dashboard.selectedRange"></app-toolbar-date-selector>
            <div style="width: 300px">
                <v-text-field
                        placeholder="Search"
                        hide-details
                        class="pa-0 ma-0 mx-2"
                        color="primary"
                        prepend-inner-icon="mdi-magnify"
                        solo
                        dense
                        v-model="$store.state.ref.dashboard.filterStr"
                ></v-text-field>
            </div>

<!--            <template v-if="showExportSelection">-->
<!--                <v-menu offset-y>-->
<!--                    <template v-slot:activator="{on}">-->
<!--                        <v-btn-->
<!--                                icon-->
<!--                                color="primary"-->
<!--                                class="mx-2"-->
<!--                                small-->
<!--                                v-on="on"-->
<!--                                :loading="showLoadingExport"-->
<!--                                :disabled="showLoadingExport"-->
<!--                        >-->
<!--                            <v-icon>mdi-microsoft-excel</v-icon>-->
<!--                        </v-btn>-->
<!--                    </template>-->

<!--                    <v-card>-->
<!--                        <v-list dense>-->
<!--                            <v-list-item @click="exportDashboardData">-->
<!--                                <v-list-item-title>Summary</v-list-item-title>-->
<!--                            </v-list-item>-->
<!--                            <v-list-item @click="exportDashboardDataDetail">-->
<!--                                <v-list-item-title>Detail</v-list-item-title>-->
<!--                            </v-list-item>-->
<!--                        </v-list>-->
<!--                    </v-card>-->

<!--                </v-menu>-->

<!--            </template>-->
            <v-btn
                    icon
                    color="primary"
                    class="mx-2"
                    small
                    @click="exportDashboardData"
            >
                <v-icon>mdi-microsoft-excel</v-icon>
            </v-btn>


            <v-btn
                    icon
                    color="primary"
                    class="mx-2"
                    small
                    @click="$store.state.ref.dashboard.showColumnSelection = true"
            >
                <v-icon>mdi-view-column</v-icon>
            </v-btn>
        </template>
    </div>
</template>

<script>
import {
    addDays,
    endOfDay, endOfMonth,
    format, isMonday,
    isSameDay,
    isSameMonth,
    isSameYear,
    startOfDay, startOfMonth,
    subDays, subMonths, subWeeks
} from "date-fns";
import AppToolbarDateSelector from "@/components/Shared/AppToolbarDateSelector.vue";

const calFmt = (date) => {
    try {
        return format(date, 'yyyy-MM-dd')
    } catch (e) {
        return null;
    }
}

export default {
    components: {AppToolbarDateSelector},
    props: {
        shown: Boolean,
    },
    data() {
        return {
            showLoadingExport: false,
            format,

        }
    },
    methods: {

        exportDashboardDataDetail() {
            this.$emit('exportDashboardDataDetail')
        },

        exportDashboardData() {
            this.$emit('exportDashboardData')
        },
    },
    computed: {
        // showExportSelection() {
        //     return this.$store.state.ref.dashboard.selectedRange.start && this.$store.state.ref.dashboard.selectedRange.end
        //             ? (
        //                     format(this.$store.state.ref.dashboard.selectedRange.start, "yyyy-MM-dd")
        //                     !== format(this.$store.state.ref.dashboard.selectedRange.end, "yyyy-MM-dd")
        //             ) :
        //             false
        // },
    },
}
</script>

<style scoped>

</style>